import * as ActionTypes from '../../constants/ActionTypes'
import store from "../../store";
import { toast  } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

export const userlogin = (req) => ({
    type: ActionTypes.USER_LOGIN_START,
    payload: req,
});

export const userloginSuccess = (req) => {
    return {
        type: ActionTypes.USER_LOGIN_SUCCESS,
        payload: req,
    };
};
export const userloginFailure = (error) => ({
    type: ActionTypes.USER_LOGIN_FAILURE,
    payload: error,
});

export const userSocaillogin = (req) => ({
    type: ActionTypes.USER_SOCIAL_LOGIN_START,
    payload: req,
});

export const userSocialloginSuccess = (req) => {
    return {
        type: ActionTypes.USER_SOCIAL_LOGIN_SUCCESS,
        payload: req,
    };
};
export const userSocialloginFailure = (error) => ({
    type: ActionTypes.USER_SOCIAL_LOGIN_FAILURE,
    payload: error,
});

export const userlogout = (req) => ({
    type: ActionTypes.USER_LOGOUT_START,
    payload: req,
});

export const userlogoutSuccess = (req) => {
    return {
        type: ActionTypes.USER_LOGOUT_SUCCESS,
        payload: req,
    };
};
export const userlogoutFailure = (error) => ({
    type: ActionTypes.USER_LOGOUT_FAILURE,
    payload: error,
});

export const userregister = (req) => ({
    type: ActionTypes.USER_REGISTER_START,
    payload: req,
});

export const userregisterSuccess = (data) => {
    return {
        type: ActionTypes.USER_REGISTER_SUCCESS,
        payload: data,
    };
};
export const userregisterFailure = (error) => ({
    type: ActionTypes.USER_REGISTER_FAILURE,
    payload: error,
});

export const userresetPassword = (req) => ({
    type: ActionTypes.USER_RESET_PASSWORD_START,
    payload: req,
});

export const userresetPasswordSuccess = (data) => {
    return {
        type: ActionTypes.USER_RESET_PASSWORD_SUCCESS,
        payload: data,
    };
};
export const userresetPasswordFailure = (error) => ({
    type: ActionTypes.USER_RESET_PASSWORD_FAILURE,
    payload: error,
});

export const usergetUserProfile = (req) => ({
    type: ActionTypes.USER_GET_USER_PROFILE_START,
    payload: req,
});

export const usergetUserProfileSuccess = (data) => {
    return {
        type: ActionTypes.USER_GET_USER_PROFILE_SUCCESS,
        payload: data,
    };
};
export const usergetUserProfileFailure = (error) => ({
    type: ActionTypes.USER_GET_USER_PROFILE_FAILURE,
    payload: error,
});

export const userupdateUserProfile = (req) => ({
    type: ActionTypes.USER_UPDATE_USER_PROFILE_START,
    payload: req,
});

export const userupdateUserProfileSuccess = (data) => {
    return {
        type: ActionTypes.USER_UPDATE_USER_PROFILE_SUCCESS,
        payload: data,
    };
};
export const userupdateUserProfileFailure = (error) => ({
    type: ActionTypes.USER_UPDATE_USER_PROFILE_FAILURE,
    payload: error,
});

export const usergetBillingAddress = (req) => ({
    type: ActionTypes.USER_GET_BILLING_ADDRESS_START,
    payload: req,
});

export const usergetBillingAddressSuccess = (data) => {
    return {
        type: ActionTypes.USER_GET_BILLING_ADDRESS_SUCCESS,
        payload: data,
    };
};
export const usergetBillingAddressFailure = (error) => ({
    type: ActionTypes.USER_GET_BILLING_ADDRESS_FAILURE,
    payload: error,
});

export const userupdateBillingAddress = (req) => ({
    type: ActionTypes.USER_UPDATE_BILLING_ADDRESS_START,
    payload: req,
});

export const userupdateBillingAddressSuccess = (data) => {
    return {
        type: ActionTypes.USER_UPDATE_BILLING_ADDRESS_SUCCESS,
        payload: data,
    };
};
export const userupdateBillingAddressFailure = (error) => ({
    type: ActionTypes.USER_UPDATE_BILLING_ADDRESS_FAILURE,
    payload: error,
});

export const usergetUserLocationAddress = (req) => ({
    type: ActionTypes.USER_GET_USER_LOCATION_START,
    payload: req,
});

export const usergetUserLocationAddressSuccess = (data) => {
    return {
        type: ActionTypes.USER_GET_USER_LOCATION_SUCCESS,
        payload: data,
    };
};
export const usergetUserLocationAddressFailure = (error) => ({
    type: ActionTypes.USER_GET_USER_LOCATION_FAILURE,
    payload: error,
});

// Virtual Try-On Profile Image Actions

export const uploadTryOnProfileImage = (req) => ({
    type: ActionTypes.UPLOAD_TRYON_PROFILE_IMAGE_START,
    payload: req,
});

export const uploadTryOnProfileImageSuccess = (data) => {
    toast.success("Profile image uploaded successfully!");
    return {
        type: ActionTypes.UPLOAD_TRYON_PROFILE_IMAGE_SUCCESS,
        payload: data,
    };
};

export const uploadTryOnProfileImageFailure = (error) => {
    toast.error(error?.statusText || "Failed to upload profile image");
    return {
        type: ActionTypes.UPLOAD_TRYON_PROFILE_IMAGE_FAILURE,
        payload: error,
    };
};

export const getTryOnProfileImage = (req) => ({
    type: ActionTypes.GET_TRYON_PROFILE_IMAGE_START,
    payload: req,
});

export const getTryOnProfileImageSuccess = (data) => {
    return {
        type: ActionTypes.GET_TRYON_PROFILE_IMAGE_SUCCESS,
        payload: data,
    };
};

export const getTryOnProfileImageFailure = (error) => ({
    type: ActionTypes.GET_TRYON_PROFILE_IMAGE_FAILURE,
    payload: error,
});

export const deleteTryOnProfileImage = (req) => ({
    type: ActionTypes.DELETE_TRYON_PROFILE_IMAGE_START,
    payload: req,
});

export const deleteTryOnProfileImageSuccess = (data) => {
    toast.success("Profile image deleted successfully");
    return {
        type: ActionTypes.DELETE_TRYON_PROFILE_IMAGE_SUCCESS,
        payload: data,
    };
};

export const deleteTryOnProfileImageFailure = (error) => {
    toast.error(error?.statusText || "Failed to delete profile image");
    return {
        type: ActionTypes.DELETE_TRYON_PROFILE_IMAGE_FAILURE,
        payload: error,
    };
};

export const getAllTryOnProfileImages = (req) => ({
    type: ActionTypes.GET_ALL_TRYON_PROFILE_IMAGES_START,
    payload: req,
});

export const getAllTryOnProfileImagesSuccess = (data) => {
    return {
        type: ActionTypes.GET_ALL_TRYON_PROFILE_IMAGES_SUCCESS,
        payload: data,
    };
};

export const getAllTryOnProfileImagesFailure = (error) => ({
    type: ActionTypes.GET_ALL_TRYON_PROFILE_IMAGES_FAILURE,
    payload: error,
});

// Virtual Try-On Generation Actions
export const generateVirtualTryOn = (productId, userImageId = null, numberOfImages = 1, forceDuplicate = false) => ({
    type: ActionTypes.GENERATE_VIRTUAL_TRYON_START,
    payload: {
        product_id: productId,
        user_image_id: userImageId,
        numberOfImages: numberOfImages,
        force_duplicate: forceDuplicate,
    },
});

export const generateVirtualTryOnSuccess = (data) => {
    toast.success("Virtual try-on generated successfully!");
    return {
        type: ActionTypes.GENERATE_VIRTUAL_TRYON_SUCCESS,
        payload: data,
    };
};

export const generateVirtualTryOnFailure = (error) => {
    toast.error(error?.statusText || "Failed to generate virtual try-on");
    return {
        type: ActionTypes.GENERATE_VIRTUAL_TRYON_FAILURE,
        payload: error,
    };
};

// Get Try-On Credits
export const getTryOnCredits = () => ({
    type: ActionTypes.GET_TRYON_CREDITS_START,
});

export const getTryOnCreditsSuccess = (data) => ({
    type: ActionTypes.GET_TRYON_CREDITS_SUCCESS,
    payload: data,
});

export const getTryOnCreditsFailure = (error) => ({
    type: ActionTypes.GET_TRYON_CREDITS_FAILURE,
    payload: error,
});

// Get Try-On History
export const getTryOnHistory = (shopId = "", limit = 20, skip = 0) => ({
    type: ActionTypes.GET_TRYON_HISTORY_START,
    payload: { shopId, limit, skip },
});

export const getTryOnHistorySuccess = (data) => ({
    type: ActionTypes.GET_TRYON_HISTORY_SUCCESS,
    payload: data,
});

export const getTryOnHistoryFailure = (error) => ({
    type: ActionTypes.GET_TRYON_HISTORY_FAILURE,
    payload: error,
});

// Get Specific Try-On
export const getTryOnDetails = (tryonId) => ({
    type: ActionTypes.GET_TRYON_DETAILS_START,
    payload: { tryonId },
});

export const getTryOnDetailsSuccess = (data) => ({
    type: ActionTypes.GET_TRYON_DETAILS_SUCCESS,
    payload: data,
});

export const getTryOnDetailsFailure = (error) => ({
    type: ActionTypes.GET_TRYON_DETAILS_FAILURE,
    payload: error,
});

// Delete Try-On
export const deleteTryOn = (req) => ({
    type: ActionTypes.DELETE_TRYON_START,
    payload: req,
});

export const deleteTryOnSuccess = (data) => {
    toast.success("Try-on deleted successfully!");
    return {
        type: ActionTypes.DELETE_TRYON_SUCCESS,
        payload: data,
    };
};

export const deleteTryOnFailure = (error) => {
    toast.error(error?.statusText || "Failed to delete try-on");
    return {
        type: ActionTypes.DELETE_TRYON_FAILURE,
        payload: error,
    };
};
